import axios from "axios";

export const getNoteCommissarioApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/nota-commissario/`, {
        params: params
    });
}

export const getNotaCommissarioByIdApi = (idNota, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/nota-commissario/${idNota}`, {
        params: params
    });
}

export const aggiornaNotaCommissarioApi = (idNota, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/nota-commissario/${idNota}`, payload, {
        params: params
    });
}

export const aggiungiNotaCommissarioApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/nota-commissario/`, payload, {
        params: params
    });
}